import { gql } from '@apollo/client';
import { CourseTopicData } from './course-topic';

export const GET_COURSE_TOPIC_ITEMS = gql`
  query GetCourseTopics($query: QueryCourseTopicInput) {
    CourseTopic_getList(query: $query) {
      data {
        ${CourseTopicData}
      }
      count
      page
      pages
      limit
    }
  }
`;

export const CREATE_COURSE_TOPIC = gql`
  mutation CreateCourseTopic($payload: CreateCourseTopicInput!) {
    CourseTopic_create(createCourseTopicInput: $payload) {
      ${CourseTopicData}
    }
  }
`;

export const UPDATE_COURSE_TOPIC = gql`
  mutation UpdateCourseTopic($payload: UpdateCourseTopicInput!) {
    CourseTopic_update(updateCourseTopicInput: $payload) {
      ${CourseTopicData}
    }
  }
`;

export const DETAIL_COURSE_TOPIC = gql`
  query GetCourseTopicById($id: String!) {
    CourseTopic_getById(id: $id) {
      ${CourseTopicData}
    }
  }
`;

export * from './course-topic';
